"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOverlappingFills = convertOverlappingFills;
const common_1 = require("./common");
function convertOverlappingFills(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const layer = problem.label ?? null;
        const net = problem.affectedItems
            .map((a) => {
            const designator = (0, common_1.sanitizeDesignator)(a.itemLabel ?? (0, common_1.getLabelForPcbNode)(nodes[a.uid]));
            const netId = (0, common_1.getNetUidForNode)(a.uid, nodes);
            if (netId) {
                designatorUidMap[designator] = netId;
            }
            return designator;
        })
            .join(", ");
        return { name: (0, common_1.sanitizeDesignator)(layer), layer: (0, common_1.sanitizeDesignator)(layer), net, designatorUidMap };
    };
}
//# sourceMappingURL=overlappingFills.js.map